import React from 'react';
import './Featuring.css';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import HomeIcon from '@mui/icons-material/Home';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PhoneIcon from '@mui/icons-material/Phone';
import OrderNowButton from './OrderNowButton';
import { Link } from 'react-router-dom';

const Featuring = () => {
  const features = [
    { icon: <ShoppingBagIcon />, title: 'Takeout', description: 'Quick and easy pickup' },
    { icon: <HomeIcon />, title: 'Catering', description: 'For special events' },
    { icon: <RestaurantIcon />, title: 'Dine In', description: 'Experience the ambiance' },
  ];

  return (
    <section className="featuring-section">
      <div className="featuring-container">
        <h2>Featuring</h2>
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">
              <LocalShippingIcon />
            </div>
            <h3>Delivery</h3>
            <p>Straight to your door</p>
            <div className="feature-button-container">
              <OrderNowButton theme="dark" />
            </div>
          </div>
          
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
          
          <div className="feature-item">
            <div className="feature-icon">
              <PhoneIcon />
            </div>
            <h3>Reservations</h3>
            <p>Book your table</p>
            <div className="feature-button-container">
              <Link to="/reservations" className="feature-link-button">
                Reserve Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Featuring; 